import React, { Component } from 'react';
import { Route } from 'react-router';
import "bootstrap/dist/css/bootstrap.css";
import UserHomePage from './components/Home/UserHomePage';

import CodeEntryPDF from './components/Code/CodeEntryPDF';
import Login from './components/DevelopmentLogin/Login';
import SurveyAnalyticsPage from './components/Analytics/SurveyAnalytics';
import CompCode from './components/Code/CompCode';
import CompCodeUnidentify from './components/Code/CompCodeUnidentify';
import CompExternalDirect from './components/Direct/CompExternalDirect';
import CompInternalDirect from './components/Direct/CompInternalDirect';
import CodePortal from './components/Code/CodePortal';




export default class App extends Component {
    displayName = App.name

    render() {        
    return (
        <div>
            <Route path='/PDir/' component={CodePortal} />
            <Route path='/CodePDF/' component={CodeEntryPDF} />
            <Route path='/DevLogin/' component={Login} />
            <Route path='/Analytics/' component={SurveyAnalyticsPage} />
            <Route exact path='/Code/' component={CompCode} />
            <Route exact path='/CU/' component={CompCodeUnidentify} />
            <Route exact path='/CodePortal/' component={CodePortal} />
            <Route path='/EDir/' component={CompExternalDirect} />
            <Route exact path='/IDir/:jumpToPage' component={CompInternalDirect} />
            <Route exact path='/IDir/' component={CompInternalDirect} />   
      </div>
    );
  }
}
